export default "assets/images/logo-black-ccfbc46d.png";